const isBrowser = typeof window !== 'undefined';
const isLocalhost = isBrowser && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '0.0.0.0'
);

const dockerLocalOrigin = isLocalhost ? window.location.origin : null;

const config = {
  development: {
    apiBaseUrl: 'http://localhost:3000/api/v1',
    proxy: 'http://localhost:3000'
  },
  production: {
    apiBaseUrl: dockerLocalOrigin ? `${dockerLocalOrigin}/api/v1` : 'https://keejani-api.devlaps.co/api/v1',
    proxy: dockerLocalOrigin || 'https://keejani-api.devlaps.co'
  }
};

const isDevelopment = process.env.NODE_ENV === 'development';
const currentConfig = isDevelopment ? config.development : config.production;

export default currentConfig;
